import { event, GtagEvent } from "./event";

export interface PostScore extends GtagEvent {
    score: number;
    level?: number;
    character?: string;
}
export const post_score = ($_:PostScore) => event('post_score',$_);